<template lang="pug">
div
  .md-headline Targets
  md-layout(:md-gutter='24')
    md-layout(md-flex='100')
      license-selector#license-selector(
        v-model='entity.licenses',
        :multiple='true',
        @created="$emit('created', $event)",
        @error="$emit('error', $event)",
        :showRequiredError='formSubmitted && entity.licenses.length == 0'
      )
</template>

<script>
  import LicenseSelector from '../license/LicenseSelector';

  export default {
    components: {
      LicenseSelector
    },
    props: {
      entity: {
        type: Object,
        required: true
      },
      formSubmitted: {
        type: Boolean,
        required: true
      },
      validations: {
        licenses: {
          type: Array,
          required: true
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .form-wrapper-frame {
    width: 100%;
    padding: 25px;
    margin-bottom: 15px;
  }

  .network > .md-layout ,
  .channel > .md-layout {
    overflow: hidden;
    max-width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/shared-components/forms/ContentTargetsForm.vue